<template>
  <span class="u-min-height-100 u-max-width-800px">
    <modal>
      <div
        slot="body"
        class="u-font-size-4 u-text-align-center u-color-grey-base u-spacing-mt-l u-spacing-mb-xl"
      >
        <div class="u-font-size-1 u-font-weight-600 u-spacing-mb-xl">
          Pause the campaign to replace the video profile
        </div>
        To update the video profile of a campaign, the campaign must be paused.
        Are you sure you want to pause the campaign and replace the video?
      </div>
      <div
        slot="footer"
        class="u-spacing-mb-l u-display-flex u-flex-direction-column u-flex-align-items-center"
      >
        <div class="u-display-flex u-flex-justify-content-center">
          <rb-checkbox
            v-model="autoEnable"
            class="u-spacing-mb-l u-width-320px"
          >
            Auto Enable campaign after Video is approved
          </rb-checkbox>
        </div>

        <div class="u-display-flex u-flex-justify-content-center">
          <rb-button
            :click-fn="closeModal"
            text="Cancel"
            class="u-spacing-mr-m"
          />
          <rb-button
            :click-fn="onApply"
            text="Pause Campaign & Replace Video"
            type="filled"
          />
        </div>
      </div>
    </modal>
  </span>
</template>
<script>
import loader from '@/components/basic/loader';
import Modal from '@/components/widgets/modal.vue';

export default {
  components: { Modal, loader },
  data() {
    return {
      autoEnable: true
    };
  },
  methods: {
    onApply() {
      this.$emit('onApply', { autoEnable: this.autoEnable });
    },
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style>
.u-max-width-800px {
  max-width: 800px;
}
</style>
